import { render, staticRenderFns } from "./vcApprovalTransaction.vue?vue&type=template&id=1ef9dd12&"
import script from "./vcApprovalTransaction.vue?vue&type=script&lang=js&"
export * from "./vcApprovalTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports